/**
 * English plurals (D217) — the one place the parser knows how a regular
 * plural is built, shared by the resolver's plural reading and the fuzzy
 * rung's legality check, so the two can never disagree about what `jars` is.
 *
 * @packageDocumentation
 */

/**
 * The singular forms an English plural may be built on, likeliest first:
 * `berries` → `berry`, `boxes` → `box` (then the same word less its `s`, harmlessly),
 * `jars` → `jar`. A word that is not a regular plural has none — `glass`
 * ends in `s` and is its own singular.
 *
 * @param word - The phrase's last word, folded
 * @returns The candidate singulars, in the order to try them
 */
export const singularFormsOf = (word: string): readonly string[] => {
	if (word.length > 3 && word.endsWith('ies')) {
		return [`${word.slice(0, -3)}y`, word.slice(0, -1)];
	}

	if (word.endsWith('es')) {
		return [word.slice(0, -2), word.slice(0, -1)];
	}

	return word.endsWith('s') && !word.endsWith('ss') ? [word.slice(0, -1)] : [];
};
